import React, { useState, useCallback } from 'react';
import { default as SayfaOturumAc } from './sayfa-oturum-ac';
import { default as SayfaMfaSec } from './sayfa-mfa-sec';
import { default as SayfaSifreDegistir } from './sayfa-sifre-degistir';
import { default as SayfaSonuc } from './sayfa-sonuc';
import {Alert, OnayKodu} from "../../components";


const SAYFA_OTURUM_AC  = 1;
const SAYFA_MFA_SEC  = 2;
const SAYFA_ONAY_KODU  = 3;
const SAYFA_SIFRE = 4;
const SAYFA_SONUC_BASARILI = 5;
const SAYFA_SONUC_HATA = 6;

// test amaçlı
// const responseOnayKodu = () => ({success:true,yontem:'sms', onaySuresi: 120,
//     message: "Lütfen 5321300101 numaralı cep telefonunuza gönderilen onay kodunu giriniz"});

export default function () {

    const [sayfa, setSayfa] = useState(SAYFA_OTURUM_AC);
    const [response, setResponse] = useState({});

    const sifreDegistir = useCallback((res) => {
        if (res.passwordRules) {
            window.__APP__.options.password.rules = res.passwordRules
        }
        setResponse(res);
        setSayfa(SAYFA_SIFRE);
    }, [])

    const mfaSecim = useCallback((res) => {
        setResponse(res);
        setSayfa(SAYFA_MFA_SEC);
    }, [])

    const mfaDogrula = useCallback((res) => {
        setResponse(res);
        setSayfa(SAYFA_ONAY_KODU);
    }, [])

    const onayKodu_onTimeout = useCallback(() => {
        // setResponse({
        //    message: 'Süre bitti'
        // });
        // TODO: tekrar sıfırlama sayfasına gönderildi,
        //  tekrar kod goder vs sonuc sayfası yapılacak
        setSayfa(SAYFA_OTURUM_AC);
    }, [])

    const onayKodu_onSuccess = useCallback((res) => {
        if (res.action === 'resume') {
            window.location = '/resume';
        } else if(res.action === 'change_password') {
            setResponse(res);
            setSayfa(SAYFA_SIFRE);
        }
    }, [])

    const onayKodu_onUnSuccess = useCallback((res) => {
        setResponse(res);
        setSayfa(SAYFA_SONUC_HATA);
    }, [])

    const sifreDegistir_onSuccess = useCallback((res) => {
        setResponse(res);
        setSayfa(SAYFA_SONUC_BASARILI);
    }, [])

    console.log('SAYFA ', sayfa)
    if (sayfa === SAYFA_OTURUM_AC)
        return <SayfaOturumAc sifreDegistir={sifreDegistir} mfaDogrula={mfaDogrula} mfaSecim={mfaSecim} />;

    if (sayfa === SAYFA_MFA_SEC)
        return <SayfaMfaSec icon="fa fa-user" items={response.items} mfaDogrula={mfaDogrula}>
            {response.message}
        </SayfaMfaSec>;

    if (sayfa === SAYFA_ONAY_KODU)
        return <OnayKodu onaySuresi={response.onaySuresi}
                         className="text-success dx-theme-accent-as-text-color"
                         url="/ui/login/dogrula"
                         icon={response.yontem === 'sms'
                             ? "fa fa-3x fa-mobile dx-theme-accent-as-text-color"
                             : "fas fa-3x fa-envelope-open-text dx-theme-accent-as-text-color"}
                         onSuccess={onayKodu_onSuccess}
                         onUnSuccess={onayKodu_onUnSuccess}
                         onTimeout={onayKodu_onTimeout}>
            {response.message}
        </OnayKodu>;

    if (sayfa === SAYFA_SIFRE)
        return <SayfaSifreDegistir onSuccess={sifreDegistir_onSuccess} reason={response.message} />;

    if (sayfa === SAYFA_SONUC_HATA)
        return <SayfaSonuc>
            <Alert type="error"
                   message={response.message}
                   iconClass="fa fa-2x fa-exclamation-circle"  />
        </SayfaSonuc>;

    if (sayfa === SAYFA_SONUC_BASARILI)
        return <SayfaSonuc>
            <Alert type="success"
                   message={response.message}
                   iconClass="fa fa-2x fa-check-circle"  />
        </SayfaSonuc>;

    return null;
}
